module.exports = __webpack_public_path__ + "static/media/employee-synchronization.e0eec1a7.md";